import $ from 'jquery';
import { bpdesktop } from './variables';
import 'slick-carousel';

const $slick_slider = $('.js__slick');
const $slick_slider_blog = $('.js__slick_blog');

if ($slick_slider.length) {
  $slick_slider.each(function () {
    let $slide = $(this).find('.slide');
    let image_width = Math.round($slide.width() ?? 0);
    let container_width = $(this).width();
    let slidesToShow = Math.round(container_width ?? 0 / image_width);
    let has_arrows = false;
    let is_autoplay = $slide.data('autoplay');
    let ms_desktop = $slide.data('ms-desktop');
    let ms_mobile = $slide.data('ms-mobile');
    let ul_classes = $slide.data('slider') === 'logo' ? 'tw-slick-ul' : 'tw-slick-ul w-72 md:w-[508px]';

    if ($slide.data('slider') === 'project') {
      slidesToShow = 1;
      ul_classes = 'tw-slick-ul absolute top-[calc(100%-0.75rem)] right-24 left-4 md:top-auto md:left-auto w-auto md:w-full md:max-w-ml-4 md:right-20 md:bottom-1';
      has_arrows = true;
    }

    $(this).slick({
      slidesToShow: slidesToShow,
      variableWidth: true,
      dots: true,
      arrows: has_arrows,
      prevArrow: '<span class="absolute top-full z-50 md:top-auto md:-bottom-2 cursor-pointer right-14 md:right-10 icon w-6 h-6 bg-ico-arrow-black rotate-180"></span>',
      nextArrow: '<span class="absolute top-full z-50 md:top-auto md:-bottom-2 cursor-pointer right-4 md:right-0 icon w-6 h-6 bg-ico-arrow-black"></span>',
      dotsClass: ul_classes,
      autoplay: is_autoplay,
      autoplaySpeed: ms_desktop,
      responsive: [
        {
          breakpoint: bpdesktop,
          settings: {
            slidesToShow: 1,
            autoplaySpeed: ms_mobile
          }
        }
      ]
    });
  });
}

if ($slick_slider_blog.length) {
  $slick_slider_blog.each(function () {
    let $slide = $(this).find('.slide');
    let is_autoplay = $slide.data('autoplay');
    let ms_desktop = $slide.data('ms-desktop');
    let ms_mobile = $slide.data('ms-mobile');

    $(this).slick({
      centerMode: true,
      slidesToShow: 1,
      variableWidth: true,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: is_autoplay,
      autoplaySpeed: ms_desktop,
      responsive: [
        {
          breakpoint: bpdesktop,
          settings: {
            centerMode: true,
            slidesToShow: 1,
            autoplaySpeed: ms_mobile
          }
        }
      ]
    });
  });
}